import { withStyles } from '@material-ui/styles';

import IntegrationWidget from './IntegrationWidget';
import styles from './styles';

export default withStyles(styles)(IntegrationWidget);
